import { Action } from '@ngrx/store';
import {
  RepositoryInfo,
  Node,
  Person,
  Group,
  NodeEntry,
  ResultSetPaging,
  UserRepresentation,
} from '@alfresco/js-api';
import {
  AppActionTypes,
  NodeActionTypes,
  RouterActionTypes,
  SnackbarAction,
  SnackbarActionTypes,
  ViewerActionTypes,
  UploadActionTypes,
  ViewNodeExtras,
} from '@alfresco/aca-shared/store';
import {
  IKeyWord,
  SelectedKeywordType,
  IEditKeyWord,
  ICopyKeyword,
  IKeywordDefinition,
  ITraverseKeyword,
  IKeywordDefinitionWithUnwrapFlag,
} from '../states';
import {
  CitationObjectModel,
  DiscardForKeyword,
  IMarginaliaDeleteDialogData,
  IPagination,
} from '../../model';

export const CHECKIN_NODE = 'CHECKIN_NODE';
export const CANCEL_CHECKOUT = 'CANCEL_CHECKOUT';
export const CHECKOUT_NODES_ACTION = 'CHECKOUT_NODES_ACTION';
export const BATCH_METADATA_UPDATE = 'BATCH_METADATA_UPDATE';
export const UPLOAD_CONTENT = 'UPLOAD_CONTENT';
export const START_PROCESS = 'START_PROCESS';
export const SET_SITES_ACTION = 'SET_SITES_ACTION';
export const SET_CURRENT_SITE = 'SET_CURRENT_SITE';
export const ENRICH = 'ENRICH_CONTENT';
export const EDIT_DOCUMENT = 'EDIT_DOCUMENT';
export const SET_CONTENT_WIDGET_ASSIGNEE_STATE =
  'SET_CONTENT_WIDGET_ASSIGNEE_STATE';
export const OPEN_COMPARE_AND_MERGE_DIALOG = 'OPEN_COMPARE_AND_MERGE_DIALOG';
export const OPEN_CREATE_TEMPLATE_DIALOG = 'OPEN_CREATE_TEMPLATE_DIALOG';
export const SET_SITE_CHILDREN = 'SET_SITE_CHILDREN';
export const SET_SITES_MANAGER = 'SET_SITES_MANAGER';
export const DOWNLOAD_ZIP = 'DOWNLOAD_ZIP';
export const SetBpmUser = 'SET_BPM_USER';
export const ASSIGN_WORKFLOW_STEP = 'ASSIGN_WORKFLOW_STEP';
export const CANCEL_WORKFLOW = 'CANCEL_WORKFLOW';
export const REASSIGN_WORKFLOW = 'REASSIGN_WORKFLOW';
export const SET_DOCUMENT_KEYWORD = 'SET_DOCUMENT_KEYWORD';
export const GET_DOCUMENT_KEYWORD = 'GET_DOCUMENT_KEYWORD';
export const ADD_NEW_KEYWORD = 'ADD_NEW_KEYWORD';
export const SELECT_KEYWORD = 'SELECT_KEYWORD';
export const EDIT_KEYWORD = 'EDIT_KEYWORD';
export const COPY_KEYWORD = 'COPY_KEYWORD';
export const EDIT_COPY_KEYWORD = 'EDIT_COPY_KEYWORD';
export const SET_DEFINITION = 'SET_DEFINITION';
export const SET_KEYWORD = 'SET_KEYWORD';
export const REORDER_KEYWORD = 'REORDER_KEYWORD';
export const DELETE_KEYWORD = 'DELETE_KEYWORD';
export const SELECTED_FOR_DELETE = 'SELECTED_FOR_DELETE';
export const KEYWORD_UNDO_REDO = 'KEYWORD_UNDO_REDO';
export const KEYWORD_TRAVERSE = 'KEYWORD_TRAVERSE';
export const ALL_DOCS_DASHBOARD_ADD_ITEM = 'ALL_DOCS_DASHBOARD_ADD_ITEM';
export const ALL_DOCS_DASHBOARD_REMOVE_ITEM = 'ALL_DOCS_DASHBOARD_REMOVE_ITEM';
export const ALL_DOCS_DASHBOARD_DESELECT_ALL =
  'ALL_DOCS_DASHBOARD_DESELECT_ALL';
export const SET_USER_ROLE_FOR_CURRENT_SITE = 'SET_USER_ROLE_FOR_CURRENT_SITE';
export const SET_CITATIONS_DATA = 'SET_CITATIONS_DATA';
export const SET_LATEST_EDITOR_CONTENT = 'SET_LATEST_EDITOR_CONTENT';
export const ON_PAGINATION_CHANGE = '[Pagination] On Change';
export const ON_PAGINATION_CHANGED = '[Pagination] On Changed';
export const SET_PAGINATION_DATA = '[Pagination] Set Data';
export const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';
export const SET_UPLOAD_COMPLETED = '[Upload] Set Completed';
export const SET_DIALOG_DATA = 'Dialog delete Data';
export const SET_FEATURE_FLAGS = '[Feature Flags] SET FEATURE FLAGS';
export const GET_FEATURE_FLAGS = '[Feature Flags] GET FEATURE FLAGS';
export const SET_SELECTED_DOCUMENTS = '[Documents] Set Selected Documents';
export const REASSIGN_TASK = 'REASSIGN_TASK';
export const SET_ROWS_DATA = 'SET_ROWS_DATA';
export const VALIDATE = 'VALIDATE';
export class CheckoutNodesAction implements Action {
  readonly type = CHECKOUT_NODES_ACTION;
  constructor(public payload: NodeEntry[] = []) {}
}

export class CheckinNodeAction implements Action {
  readonly type = CHECKIN_NODE;
  constructor(public payload: NodeEntry) {}
}

export class CancelCheckoutAction implements Action {
  readonly type = CANCEL_CHECKOUT;
  constructor(public payload?: any) {}
}

export class BatchMetadataUpdateAction implements Action {
  readonly type = BATCH_METADATA_UPDATE;
  constructor(public payload?: any) {}
}

export class UploadContentAction implements Action {
  readonly type = UPLOAD_CONTENT;
  constructor(public payload: any) {}
}

export class StartProcessAction implements Action {
  readonly type = START_PROCESS;
  constructor(public payload: NodeEntry[] = []) {}
}

export class EditDocumentAction implements Action {
  readonly type = EDIT_DOCUMENT;
  constructor(public payload: any = { currentPath: '' }) {}
}

export class SetSitesAction implements Action {
  readonly type = SET_SITES_ACTION;
  constructor(public payload: any) {}
}

export class SetCurrentSiteAction implements Action {
  readonly type = SET_CURRENT_SITE;
  constructor(public payload: any) {}
}

export class SetContentWidgetAssigneeStateAction implements Action {
  readonly type = SET_CONTENT_WIDGET_ASSIGNEE_STATE;
  constructor(public payload: any) {}
}

export class OpenCompareAndMergeDialogAction implements Action {
  readonly type = OPEN_COMPARE_AND_MERGE_DIALOG;
}

export class EnrichAction implements Action {
  readonly type = ENRICH;
  constructor(public payload: NodeEntry[]) {}
}

export class SetSiteChildrenAction implements Action {
  readonly type = SET_SITE_CHILDREN;
  constructor(public payload: any) {}
}

export class OpenCreateTemplateDialogAction implements Action {
  readonly type = OPEN_CREATE_TEMPLATE_DIALOG;
}

export class SetSiteManagerAction implements Action {
  readonly type = SET_SITES_MANAGER;
  constructor(public payload: string) {}
}

export class SnackbarErrorAction implements SnackbarAction {
  readonly type = SnackbarActionTypes.Error;
  userAction?: SnackbarUserAction;
  duration = 4000;
  constructor(public payload: string, public params?: Object) {}
}

export class SnackbarInfoAction implements SnackbarAction {
  readonly type = SnackbarActionTypes.Info;
  userAction?: SnackbarUserAction;
  duration = 4000;
  constructor(public payload: string, public params?: Object) {}
}

export class SnackbarWarningAction implements SnackbarAction {
  readonly type = SnackbarActionTypes.Warning;
  userAction?: SnackbarUserAction;
  duration = 4000;
  constructor(public payload: string, public params?: Object) {}
}

export class SnackbarUserAction {
  constructor(public title: string, public action: Action) {}
}

export class NavigateRouteAction implements Action {
  readonly type = RouterActionTypes.NavigateRoute;
  constructor(public payload: any[]) {}
}

export class NavigateToParentFolder implements Action {
  readonly type = RouterActionTypes.NavigateParentFolder;
  constructor(public payload: NodeEntry) {}
}

export class UndoDeleteNodesAction implements Action {
  readonly type = NodeActionTypes.UndoDelete;
  constructor(public payload: any[] = []) {}
}

export class ReloadDocumentListAction implements Action {
  readonly type = AppActionTypes.ReloadDocumentList;
  constructor(public payload?: any) {}
}

export class SetInfoDrawerStateAction implements Action {
  readonly type = AppActionTypes.SetInfoDrawerState;
  constructor(public payload: boolean) {}
}

export class SetRepositoryInfoAction implements Action {
  readonly type = AppActionTypes.SetRepositoryInfo;
  constructor(public payload: RepositoryInfo) {}
}

export class SetSelectedNodesAction implements Action {
  readonly type = NodeActionTypes.SetSelection;
  constructor(public payload: NodeEntry[] = []) {}
}

export class SetCurrentUrlAction implements Action {
  readonly type = AppActionTypes.SetCurrentUrl;
  constructor(public payload: string) {}
}

export class ViewFileAction implements Action {
  readonly type = ViewerActionTypes.ViewFile;
  constructor(public payload?: NodeEntry, public parentId?: string) {}
}

export class SetCurrentFolderAction implements Action {
  readonly type = AppActionTypes.SetCurrentFolder;

  constructor(public payload: Node) {}
}

export class UploadFileVersionAction implements Action {
  readonly type = UploadActionTypes.UploadFileVersion;

  constructor(public payload: CustomEvent) {}
}

export class ViewNodeAction implements Action {
  readonly type = ViewerActionTypes.ViewNode;

  constructor(public nodeId: string, public viewNodeExtras?: ViewNodeExtras) {}
}

export class CloseAllModalsAction implements Action {
  readonly type = CLOSE_ALL_MODALS;

  constructor() {}
}

export class ResetSelectionAction implements Action {
  readonly type = AppActionTypes.ResetSelection;

  constructor(public payload?: any) {}
}

export class SetUserProfileAction implements Action {
  readonly type = AppActionTypes.SetUserProfile;

  constructor(public payload: { person: Person; groups: Group[] }) {}
}

export class DownloadZipAction implements Action {
  readonly type = DOWNLOAD_ZIP;

  constructor() {}
}

export class ToggleInfoDrawerAction implements Action {
  readonly type = AppActionTypes.ToggleInfoDrawer;
}

export class SetBpmUserAction implements Action {
  readonly type = SetBpmUser;

  constructor(public payload: { bpmUser: UserRepresentation }) {}
}

export class AssignWorkflowStepAction implements Action {
  readonly type = ASSIGN_WORKFLOW_STEP;
  constructor(public payload: NodeEntry) {}
}

export class CancelWorkflowAction implements Action {
  readonly type = CANCEL_WORKFLOW;
  constructor(public payload: NodeEntry) {}
}

export class ReassignWorkflowAction implements Action {
  readonly type = REASSIGN_WORKFLOW;
  constructor(public payload: NodeEntry) {}
}

export class SetKeyWordAction implements Action {
  readonly type = SET_DOCUMENT_KEYWORD;
  constructor(public payload: IKeyWord[]) {}
}

export class GetKeyWordAction implements Action {
  readonly type = GET_DOCUMENT_KEYWORD;
  constructor(public payload: { nodeId: string }) {}
}

export class AddNewKeyword implements Action {
  readonly type = ADD_NEW_KEYWORD;
  constructor(public payload: IKeyWord) {}
}

export class SelectKeyword implements Action {
  readonly type = SELECT_KEYWORD;
  constructor(public payload: SelectedKeywordType) {}
}

export class EditKeyword implements Action {
  readonly type = EDIT_KEYWORD;
  constructor(public payload: IEditKeyWord) {}
}

export class CopyKeyword implements Action {
  readonly type = COPY_KEYWORD;
  constructor(public payload: ICopyKeyword) {}
}

export class EditCopiedKeyword implements Action {
  readonly type = EDIT_COPY_KEYWORD;
  constructor(public payload: IKeyWord) {}
}

export class SetDefinitionEditorAction implements Action {
  readonly type = SET_DEFINITION;
  constructor(public payload: string) {}
}

export class SetKeywordEditorAction implements Action {
  readonly type = SET_KEYWORD;
  constructor(public payload: string) {}
}

export class ReorderKeywordAction implements Action {
  readonly type = REORDER_KEYWORD;
  constructor() {}
}

export class DeleteKeywordAction implements Action {
  readonly type = DELETE_KEYWORD;
  constructor(
    public payload: {
      docRefId: string;
      keyword: IKeywordDefinition;
      prefLabelExist?: boolean;
    }
  ) {}
}

export class SelectedForDeleteAction implements Action {
  readonly type = SELECTED_FOR_DELETE;
  constructor(public payload: IKeywordDefinitionWithUnwrapFlag) {}
}

export class KeywordUndoRedoAction implements Action {
  readonly type = KEYWORD_UNDO_REDO;
  constructor(
    public payload: {
      operation: 'undo' | 'redo';
      keywordToUndo: DiscardForKeyword[];
      keywordToRedo: DiscardForKeyword[];
    }
  ) {}
}

export class KeywordTraverseAction implements Action {
  readonly type = KEYWORD_TRAVERSE;
  constructor(public payload: ITraverseKeyword) {}
}

export class AllDocsDashboardAddItemAction implements Action {
  readonly type = ALL_DOCS_DASHBOARD_ADD_ITEM;
  constructor(public payload: NodeEntry, public pageNumber: number) {}
}

export class AllDocsDashboardRemoveItemAction implements Action {
  readonly type = ALL_DOCS_DASHBOARD_REMOVE_ITEM;
  constructor(public payload: NodeEntry, public pageNumber: number) {}
}

export class AllDocsDashboardDeselectAllAction implements Action {
  readonly type = ALL_DOCS_DASHBOARD_DESELECT_ALL;
  constructor() {}
}

export class SetUserRoleForCurrentSiteAction implements Action {
  readonly type = SET_USER_ROLE_FOR_CURRENT_SITE;
  constructor(public payload: string) {}
}

export class ShowLoaderAction implements Action {
  readonly type = AppActionTypes.ShowLoaderAction;

  constructor(public payload: boolean) {}
}

export class SetCitationsData implements Action {
  readonly type = SET_CITATIONS_DATA;
  constructor(public payload: CitationObjectModel) {}
}

export class SetLatestEditorContentAction implements Action {
  readonly type = SET_LATEST_EDITOR_CONTENT;
  constructor(public payload: string) {}
}

export class SetPaginationChange implements Action {
  readonly type = ON_PAGINATION_CHANGE;
  constructor(public payload: IPagination) {}
}

export class SetPaginationData implements Action {
  readonly type = SET_PAGINATION_DATA;
  constructor(public payload: ResultSetPaging) {}
}

export class SetUploadCompletedAction implements Action {
  readonly type = SET_UPLOAD_COMPLETED;
  constructor(public payload: boolean) {}
}

export class SetFeatureFlags implements Action {
  readonly type = SET_FEATURE_FLAGS;
  constructor(public payload: { flags: { [key: string]: boolean } }) {}
}

export class GetFeatureFlags implements Action {
  readonly type = GET_FEATURE_FLAGS;
  constructor(public payload: { person: Person; groups: string[] }) {}
}

/**
 * Stores the data of the selected document when a document is selected or unselected.
 * The `url` property is optional.
 */
export class SetSelectedDocumentsAction implements Action {
  readonly type = SET_SELECTED_DOCUMENTS;
  constructor(public payload: { id: string; name: string; url?: string }[]) {}
}

export class ViewReassignTaskAction implements Action {
  readonly type = REASSIGN_TASK;
  constructor(public payload: any) {}
}

export class SetRowsDataAction implements Action {
  readonly type = SET_ROWS_DATA;
  constructor(public payload: any[]) {}
}

export class SetTargetDeleteDialogData implements Action {
  readonly type = SET_DIALOG_DATA;
  constructor(public payload: IMarginaliaDeleteDialogData) {}
}

export class ValidateAction implements Action {
  readonly type = VALIDATE;
  constructor(public payload: { nodeIds: string[] }) {}
}
